import { GameType } from './const'

import { GameEntity } from './types'

export const p7Store = {
  apple: {
    aviaAppId: '116',
    downloadLink: 'https://apps.apple.com/app/id1402595440',
  },
  galaxy: {
    aviaAppId: '113',
    downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.pocket7games.samsung',
  },
  android: {
    aviaAppId: '112',
    downloadLink: 'https://www.aviagames.com/apk/p7/pocket7games_Release.apk',
  },
}

export const GamesStore: Record<GameType, GameEntity['store']> = {
  [GameType.SolitaireClash]: {
    apple: {
      aviaAppId: '1000',
      downloadLink: 'https://apps.apple.com/app/id1589643727',
    },
    galaxy: {
      aviaAppId: '1002',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.mtp.solitaire.samsung',
    },
    android: {
      aviaAppId: '200021',
      downloadLink: 'https://www.aviagames.com/apk/mtp/SC-OfficialHost_Release.apk',
    },
  },
  [GameType.BingoClash]: {
    apple: {
      aviaAppId: '118',
      downloadLink: 'https://apps.apple.com/app/id1523820531',
    },
    galaxy: {
      aviaAppId: '110',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.bingo.samsung',
    },
    android: {
      aviaAppId: '51',
      downloadLink: 'https://www.aviagames.com/apk/p7/bingo_Release.apk',
    },
  },
  [GameType.BingoTour]: {
    apple: {
      aviaAppId: '1001',
      downloadLink: 'https://apps.apple.com/app/id1594170490',
    },
    galaxy: {
      aviaAppId: '1003',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.mtp.bingobattle.samsung',
    },
    android: {
      aviaAppId: '200001',
      downloadLink: 'https://www.aviagames.com/apk/mtp/BT-OfficialHost_Release.apk',
    },
  },
  [GameType.EightBallStrike]: {
    apple: {
      aviaAppId: '1010',
      downloadLink: 'https://apps.apple.com/app/id1637363937',
    },
    galaxy: {
      aviaAppId: '1011',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.mtp.billiards.samsung',
    },
  },
  [GameType.SolitaireVenture]: {
    apple: {
      aviaAppId: '10019',
      downloadLink: 'https://apps.apple.com/app/id6475655147',
    },
    android: {
      aviaAppId: '200020',
      downloadLink: 'https://www.aviagames.com/apk/ugx/SolitaireVenture.apk',
    },
  },
  [GameType.Pocket7Games]: p7Store,
  [GameType.Blockolot]: {
    apple: {
      aviaAppId: '1004',
      downloadLink: 'https://apps.apple.com/app/id1609403287',
    },
    galaxy: {
      aviaAppId: '1005',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.mtp.block.samsung',
    },
    android: {
      aviaAppId: '200002',
      downloadLink: 'https://www.aviagames.com/apk/mtp/BLK-OfficialHost_Release.apk',
    },
  },
  [GameType.BubbleBuzz]: {
    apple: {
      aviaAppId: '1006',
      downloadLink: 'https://apps.apple.com/app/id1625671597',
    },
    galaxy: {
      aviaAppId: '200023',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.mtp.bubbleshoot.samsung',
    },
    android: {
      aviaAppId: '1007',
      downloadLink: 'https://www.aviagames.com/apk/mtp/BBS-OfficialHost_Release.apk',
    },
  },
  [GameType.CashPool]: {
    apple: {
      aviaAppId: '10009',
      downloadLink: 'https://apps.apple.com/app/id6448969628',
    },
  },
  [GameType.SolitaireInfinite]: {
    apple: {
      aviaAppId: '1015',
      downloadLink: 'https://apps.apple.com/app/id6478478655',
    },
    android: {
      aviaAppId: '200029',
      downloadLink: 'https://www.aviagames.com/apk/mtp/SCI-OfficialHost_Release.apk',
    },
  },
  [GameType.SolitaireSlam]: {
    apple: {
      aviaAppId: '188',
      downloadLink: 'https://apps.apple.com/app/id6478206303',
    },
    android: {
      aviaAppId: '200027',
      downloadLink: 'https://www.aviagames.com/apk/p7/solitaireslam_Release.apk',
    },
  },
  [GameType.BingoBliss]: {
    apple: {
      aviaAppId: '168',
      downloadLink: 'https://apps.apple.com/app/id6467689290',
    },
    galaxy: {
      aviaAppId: '169',
      downloadLink: 'https://galaxystore.samsung.com/detail/co.aviagames.bingobliss.samsung',
    },
    android: {
      aviaAppId: '200026',
      downloadLink: 'https://www.aviagames.com/apk/p7/bingobliss_Release.apk',
    },
  },
  [GameType.MatchNFlip]: p7Store,
  [GameType.PlaySolitaireOnline]: p7Store,
  [GameType.TwentyOneGold]: p7Store,
  [GameType.TileBlitz]: p7Store,
  [GameType.NumbersBlitz]: p7Store,
  [GameType.PoolClash]: p7Store,
  [GameType.DunkShot]: p7Store,
  [GameType.Dominoes]: p7Store,
}

export const GameAppStore = Object.fromEntries(
  Object.entries(GamesStore).map(([gameType, platforms]) => [
    gameType,
    Object.fromEntries(Object.entries(platforms).map(([platform, { downloadLink }]) => [platform, downloadLink])),
  ]),
) as Record<GameType, Partial<{ apple: string; galaxy: string; android: string }>>
